import React from 'react'
import HttpRequest from "../../../HttpRequest";
import {Tools} from "../../../Tools";
import Loader from "../../../components/Loader";
import ErrorPage from "../../../components/ErrorPage";
import Route, {default as Links} from "../../../Route";
import AuthenticationAPI from "../../../services/AuthenticationAPI";
import MessageBuilder from "../../../components/MessageBuilder";
import Components from "../../../components";


const
    formFields = {
        email: "",
        oldPassword: "",
        password: "",
        confirmPassword: "",
    },
    disabledAttribute = {
        disabled: "disabled",
    },
    editButton = {
        id: "",
        set: {
            label: "Enrégistrer",
            action: "POST",
            attributes: disabledAttribute,
        }
    },
    loadingInButton = (<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"/>Waiting...</>),
    fieldsToActiveEditPwdButton = ["oldPassword", "password", "confirmPassword", ],
    fieldsToActiveEditEmailButton = ["email"]
;

class Member extends React.Component{
    static Views = {
        my_profile : {
            id: "my-profile",
            route: Route.APIMembersProfile,
            method: ""
        },
        edit_profile : {
            id: "edit-profile",
            route: Route.APIMembersProfile,
            method: ""
        },
        edit_email_and_pwd : {
            id: "edit-email-and-pwd",
            route: Route.APIMembersProfile,
            method: ""
        },
    };
    constructor(props) {
        super(props);

        this.httpClient = new HttpRequest();
        this.state = {
            server: {},
            isLoadCompleted: false,
            hasPageError: false,
            hasError: false,
            memberEdited: false,
            formEditEmail: {
                fieldValues: Tools.Clone(formFields),
                buttons: Tools.Clone(editButton),
            },
            formEditPwd: {
                fieldValues: Tools.Clone(formFields),
                buttons: Tools.Clone(editButton),
            },
            member: null
        };

        this.formEditEmailRef = React.createRef();
        this.formEditPwdRef = React.createRef();
        this.counterRef = React.createRef();

        this.handleButtonClicked = this.handleButtonClicked.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.buildRoute();
    }

    getCurrentForm(event){
        let currentForm = null, element = null;
        const data_form_name = event.target.getAttribute("data-form");
        if(this.formEditEmailRef && this.formEditEmailRef.current && data_form_name === this.formEditEmailRef.current.getAttribute("name")){
            currentForm = this.state.formEditEmail;
            element = this.formEditEmailRef.current;
        }
        if(this.formEditPwdRef && this.formEditPwdRef.current && data_form_name === this.formEditPwdRef.current.getAttribute("name")){
            currentForm = this.state.formEditPwd;
            element = this.formEditPwdRef.current;
        }
        return {
            name: data_form_name,
            data: currentForm,
            element: element,
        };
    }

    handleSubmit(event){
        event.preventDefault();
    }

    handleChange(field, event){
        const currentForm = this.getCurrentForm(event);
        let
            form = currentForm.data,
            count = 0,
            fieldsToActivate = []
        ;

        if(form){
            form.fieldValues[field] = event.target.value;

            if(currentForm.name === "formEditEmail"){
                fieldsToActivate = fieldsToActiveEditEmailButton;
            }
            else if(currentForm.name === "formEditPwd"){
                fieldsToActivate = fieldsToActiveEditPwdButton;
            }

            fieldsToActivate.forEach(function (key) {
                if(form.fieldValues[key]){
                    count++;
                }
            });
            form.buttons["set"].attributes = count === fieldsToActivate.length ? null : disabledAttribute;
            this.setState({form: form});
        }

    }

    handleButtonClicked(event){
        // Here we add the loader in the button
        const currentForm = this.getCurrentForm(event);
        let form = currentForm.data,
            newButtonLoader = Tools.Clone(editButton)
        ;

        if(form){
            newButtonLoader["set"].label = loadingInButton;
            newButtonLoader["set"].attributes = disabledAttribute;
            form.buttons = newButtonLoader;

            currentForm.element.classList.add("cancel-events");
            currentForm.element.querySelectorAll("input").forEach((input) => {
                input.blur();
            });

            this.setState({form: form});
            let data = {
                action: currentForm.name,
                ...this.state.form.fieldValues,
            }

            // Call to the API
            const _self = this, url = Links.APIMembersProfileEditEmailPwd.replace("{idOrAccessToken}", AuthenticationAPI.getCurrentUser().accessToken);
            this.httpClient.request(url, "PUT", {}, data).then(function (response){
                _self.server = response;
                const state = {server: response, memberEdited: _self.server.code === 200, showAlert: true, action: currentForm.name, ...response.data};
                form.buttons = editButton;
                form.buttons.set.attributes = null;
                state[currentForm.name] = form;
                currentForm.element.classList.remove("cancel-events");
                _self.setState({...state});
            }).catch(function (error){
                _self.server = error;
                const state = {server: error, showAlert: true, hasAsyncError: true, action: currentForm.name};
                form.buttons = editButton;
                form.buttons.set.attributes = null;
                state[currentForm.name] = form;
                currentForm.element.classList.remove("cancel-events");
                _self.setState({...state});
            });
        }
    }

    buildRoute(){
        this.currentRoute = this.props.view.route;
        if(this.currentRoute.includes("idOrAccessToken") && AuthenticationAPI.getCurrentUser()){
            this.currentRoute = this.currentRoute.replace("{idOrAccessToken}", AuthenticationAPI.getCurrentUser().accessToken);
        }
    }


    render(){
        let element = <h3 className="">Aucune données !</h3>;
        if(!this.state.isLoadCompleted){
            element = <Loader />;
        }
        else if(this.state.hasError){
            const text = this.state.server && this.state.server.message ? "<h1>"+ this.state.server.message +"</h1>" : "";
            element = <ErrorPage data={{content: text}} />;
        }
        else if(this.state.member){
            const member = this.state.member;

            if(this.props.view.id === Member.Views.my_profile.id){
                element = (
                    <>
                        <br/>
                        <h3 className="">{this.state.server.message}</h3>
                        <div key={member.slug} className="row ">
                            <div className="col-md-3">
                                <img src={Route.APIBaseUrl + Route.APILoadMemberFile + member.avatar} className="img-thumbnail img-responsive" alt={member.name + " avatar"} width="300" />
                            </div>
                            <div className="col-md-9 paragraph ">
                                <h4>{member.civility + ". " + member.name.toUpperCase() + " " + member.firstName}</h4>
                                <div>Email : <strong>{member.email}</strong></div>
                                <div>Téléphone : <strong>{member.phone}</strong></div>
                                <div>Date de demande : <strong>{member.createdAt}</strong></div>
                                <div>Ville : <strong>{member.city}</strong></div>
                                <br/>

                                <fieldset>
                                    <legend><strong>Parcours</strong></legend>
                                    <div>Cycle : <strong>{member.cycle.toUpperCase()}, </strong>{member.hasFinishedCycle ? "a" : "n'a pas" } terminé son cycle</div>
                                    <div>Promotion : <strong>{member.promotion}</strong></div>
                                </fieldset>
                                <br/>

                                <fieldset>
                                    <legend><strong>Qualification</strong></legend>
                                    <div>Profession : <strong>{member.profession  && member.profession.name ? member.profession.name : ""}</strong></div>
                                    <div>Fonction occupée : <strong>{member.function}</strong></div>
                                    <div>Lieu de travail : <strong>{member.workPlace}</strong></div>
                                </fieldset>
                            </div>
                        </div>
                    </>
                );
            }
            else if(this.props.view.id === Member.Views.edit_email_and_pwd.id ){

                let
                    emailOrPasswordServerMessage = "",
                    alertClass = Components.Dialogs.ALERT_TYPES.DANGER,
                    emailServerMessage = "",
                    passwordServerMessage = ""
                ;

                if(this.state.showAlert || this.state.memberEdited){
                    let content = "",
                        messageBuilder = MessageBuilder.create();

                    if(this.state.hasAsyncError){
                        content = "Nos serveurs sont en maintenance. Revenez ultérieurement !";
                    }
                    else{
                        if(this.server.data && this.server.data.hasOwnProperty("fields_error")){
                            Object.keys(this.server.data.fields_error).forEach((field) => {
                                messageBuilder.addMessage(this.server.data.fields_error[field].label);
                            });
                            content = messageBuilder.getMessage();
                        }
                        if(!content && this.server.message){
                            content = this.server.message;
                        }
                        if(this.state.memberEdited){
                            alertClass = Components.Dialogs.ALERT_TYPES.SUCCESS;
                            content += '<div><br/><strong>Vous allez être redirigé dans <span id="counter" data-counter="10">10</span> secondes.</strong></div>';
                        }
                    }
                    const serverMessage = <Components.Dialogs.AlertDialog  data={{content: content, iconClass: "", alertClass: alertClass}} />;

                    if(this.state.action === "formEditEmail"){
                        emailOrPasswordServerMessage = serverMessage;
                        emailServerMessage = serverMessage;
                    }
                    else if(this.state.action === "formEditPwd"){
                        emailOrPasswordServerMessage = serverMessage;
                        passwordServerMessage = serverMessage;
                    }
                }

                if(alertClass === Components.Dialogs.ALERT_TYPES.SUCCESS){
                    element = <div className="row">
                        <div className="col-md-2"></div>
                        <div className="col-md-8" ref={this.counterRef}>
                            {emailOrPasswordServerMessage}
                        </div>
                    </div>
                }
                else{
                    element = <>
                        <br/>
                        <h3 className="">
                            {
                                member.hasTempPassword ? "Modifier le mot de passe temporaire" : "Modification de l'email et du mot de passe"
                            }
                        </h3>
                        <div className="row">
                            <div className="col-md-2"></div>
                            <div className="col-md-8">
                                {
                                    member.hasTempPassword ? "" :
                                        <>
                                            <fieldset className="mt-6">
                                                <legend><strong>Modifier l'adresse mail</strong></legend>
                                                {emailServerMessage}
                                                <form name="formEditEmail" ref={this.formEditEmailRef} onSubmit={this.handleSubmit} encType="multipart/form-data">
                                                    <div className="row mb-4">
                                                        <div className="col-md-12">
                                                            <label htmlFor="email">Email *</label>
                                                            <input data-form="formEditEmail" id="email" className="form-control input-email input-lg" type="text" name="email"
                                                                   required onChange={this.handleChange.bind(this, "email")} value={this.state.formEditEmail.fieldValues.email} />
                                                        </div>
                                                    </div>
                                                    <button data-form="formEditEmail" className="btn btn-primary btn-lg btn-block" type="submit" {...this.state.formEditEmail.buttons.set.attributes} onClick={this.handleButtonClicked} data-id={this.state.formEditEmail.buttons.id} data-action={this.state.formEditEmail.buttons.set.action}>{this.state.formEditEmail.buttons.set.label}</button>
                                                </form>
                                            </fieldset>
                                            <br/><br/>
                                        </>
                                }

                                <fieldset className="mt-6">
                                    <legend><strong>Modifier le mot de passe</strong></legend>
                                    {passwordServerMessage}
                                    <form name="formEditPwd" ref={this.formEditPwdRef} onSubmit={this.handleSubmit} encType="multipart/form-data">
                                        <div className="row mb-4">
                                            <div className="col-md-12">
                                                <label htmlFor="oldPassword">Ancien mot de passe *</label>
                                                <input data-form="formEditPwd" id="oldPassword" className="form-control input-oldPassword input-lg" type="password" name="oldPassword"
                                                       required onChange={this.handleChange.bind(this, "oldPassword")} value={this.state.formEditPwd.fieldValues.oldPassword} />
                                            </div>
                                        </div>
                                        <div className="row mb-4">
                                            <div className="col-md-12">
                                                <label htmlFor="password">Nouveau mot de passe *</label>
                                                <input data-form="formEditPwd" id="password" type="password" className="form-control input-password input-lg" name="password"
                                                       required onChange={this.handleChange.bind(this, "password")} value={this.state.formEditPwd.fieldValues.password} />
                                            </div>
                                        </div>
                                        <div className="row mb-4">
                                            <div className="col-md-12">
                                                <label htmlFor="confirmPassword">Confirmer le nouveau mot de passe *</label>
                                                <input data-form="formEditPwd" id="confirmPassword" type="password" className="form-control input-confirmPassword input-lg" name="confirmPassword"
                                                       required onChange={this.handleChange.bind(this, "confirmPassword")} value={this.state.formEditPwd.fieldValues.confirmPassword} />
                                            </div>
                                        </div>
                                        <button data-form="formEditPwd" id="formEditPwd" className="btn btn-primary btn-lg btn-block" type="submit" {...this.state.formEditPwd.buttons.set.attributes} onClick={this.handleButtonClicked} data-id={this.state.formEditPwd.buttons.id} data-action={this.state.formEditPwd.buttons.set.action}>{this.state.formEditPwd.buttons.set.label}</button>
                                    </form>
                                </fieldset>
                            </div>
                        </div>
                    </>
                }
            }
        }

        return element;
    }


    componentDidMount() {
        this.loadMember();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.view.id !== prevProps.view.id){
            this.setState({member: [], isLoadCompleted: false});
            this.buildRoute();
            this.loadMember();
        }

        if(this.state.memberEdited !== prevState.memberEdited && this.counterRef.current){
            const counter = this.counterRef.current.querySelector("#counter");
            if(counter){
                const intervalID = setInterval(() => {
                    let count = parseInt(counter.getAttribute("data-counter"));
                    count = count > 0 ? count - 1 : 0;

                    counter.setAttribute("data-counter", count + "");
                    counter.innerHTML = count + "";

                    if(count === 0){
                        window.location = Route.SignIn.link;
                        clearInterval(intervalID);
                    }
                }, 1000);
            }
        }
    }

    loadMember(){
        const _self = this;
        if(AuthenticationAPI.getCurrentUser()){
            this.currentRoute += AuthenticationAPI.user.accessToken;
        }
        this.httpClient.request(this.currentRoute, "GET", {}).then(function (response){
            _self.server = response;
            const
                member = response.data.member,
                editEmailFieldValue = _self.state.formEditEmail.fieldValues;

            editEmailFieldValue.email = member.email;

            const state = {
                server: response,
                isLoadCompleted: true,
                hasError: response.code === 0,
                formEditEmail: {
                    buttons: _self.state.formEditEmail.buttons,
                    fieldValues: {...editEmailFieldValue},
                },
                ...response.data
            };
            _self.setState({...state});
        }).catch(function (error){
            _self.server = error;
            _self.setState({server: error, hasError: true });
        });
    }
}

export default Member;